var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeetDesign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_911_47443)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.89452 21.4403C2.89452 18.6471 5.16671 16.3749 7.95992 16.3749C10.7531 16.3749 13.0253 18.6471 13.0253 21.4403C13.0253 24.2335 10.7531 26.5057 7.95992 26.5057C5.16671 26.5057 2.89452 24.2335 2.89452 21.4403ZM21.7089 21.4403C21.7089 24.2335 23.9811 26.5057 26.7743 26.5057C29.5675 26.5057 31.8397 24.2335 31.8397 21.4403C31.8397 18.6471 29.5675 16.3749 26.7743 16.3749C23.9811 16.3749 21.7089 18.6471 21.7089 21.4403ZM30.3924 27.953H23.1561C20.7624 27.953 18.8143 29.901 18.8143 32.2947V35.1893H34.7342V32.2947C34.7342 29.901 32.7862 27.953 30.3924 27.953ZM21.6047 13.4804H26.0506V3.41906C26.0506 1.78511 24.7206 0.455078 23.0867 0.455078H11.6475C10.0136 0.455078 8.68355 1.78366 8.68355 3.41906V13.4804H13.3177L15.9719 15.8206C16.3916 16.1911 16.917 16.3764 17.4423 16.3764C17.9605 16.3764 18.4786 16.194 18.8867 15.8322L21.6047 13.4818V13.4804ZM11.5781 27.953H4.34177C1.94801 27.953 0 29.901 0 32.2947V35.1893H15.9198V32.2947C15.9198 29.901 13.9718 27.953 11.5781 27.953Z",
    fill: "#406FBF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_911_47443"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.7342,
    height: 34.7342,
    fill: "white",
    transform: "translate(0 0.455078)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeetDesign);
export default __webpack_public_path__ + "static/media/meet-design.5890e05786c623dee729ad4b97b4eff0.svg";
export { ForwardRef as ReactComponent };